"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_4 = require("@biomemakers/bmk_ui_framework");
const TableProposalsRow_vue_1 = __importDefault(require("./TableProposalsRow.vue"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let TableProposals = class TableProposals extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // MixPanel init
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.eventTracker = new EventTracker_1.default();
        this.criteriaArr = [];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    chooseSortable(c) {
        this.trackInMixpanel(c);
        if (this.isAllDownloaded) {
            this.$emit('updateSortable', c);
        }
    }
    loadProposal(id) {
        this.eventTrackerListener('loadProposal', { proposalId: id });
        this.$emit('loadproposal', id);
    }
    trackInMixpanel(value) {
        const originModule = localStorage.getItem('currentModule');
        const criteria = value;
        let direction = this.direction;
        this.criteriaArr.push(criteria);
        if (this.criteriaArr.length >= 2) {
            if (this.criteriaArr[0] !== this.criteriaArr[1]) {
                direction = 0;
            }
            this.criteriaArr.shift();
        }
        if (direction === 0) {
            direction = 1;
        }
        else if (direction === 1) {
            direction = -1;
        }
        else if (direction === -1) {
            direction = 0;
        }
        this.mixpanelHandler.trackEvent('proposalsListSorting', {
            direction: direction,
            criteria: criteria,
            origin: originModule,
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableProposals.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProposals.prototype, "criteria", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TableProposals.prototype, "direction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableProposals.prototype, "isAllDownloaded", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableProposals.prototype, "proposals", void 0);
TableProposals = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_2.TableHeader,
            TableBody: bmk_ui_framework_4.TableBody,
            TableHeaderCell: bmk_ui_framework_3.TableHeaderCell,
            TableProposalsRow: TableProposalsRow_vue_1.default,
        },
    })
], TableProposals);
exports.default = TableProposals;
